<template>
  <section class="swiper-content">
    <section class="carousel-wrap"
             id="carousel">
      <span @click="changepage('left')"
            class="iconfont change-button left">&#xe602;</span>

      <transition-group tag="ul"
                        class="slide-ul"
                        name="list">
        <li v-for="(item,index) in articleL"
            :key="item.link"
            v-show="index===currentIndex"
            @mouseenter="stop"
            @mouseleave="go">
          <section>
            <a :href="item.link"
               target="_blank">
              <img :src="item.picture+'?x-oss-process=image/resize,m_fixed,w_558,h_326/quality,Q_60'"
                   target="_blank"
                   :alt="item.title">
            </a>
          </section>
          <a :href="item.link"
             target="_blank"
             class="title">
            <h2>{{item.title}}</h2>
          </a>
        </li>
      </transition-group>

      <span @click="changepage('right')"
            class="iconfont change-button right">&#xe66a;</span>

      <section class="carousel-items"
               @mouseenter="stop"
               @mouseleave="go">
        <span v-for="(item,index) in articleL.length"
              :class="{'active':index===currentIndex}"
              @click="change(index)"
              :key="item.link"></span>
      </section>
    </section>

    <section class="banner-right">
      <a :href="item.link"
         target="_blank"
         v-for="item in articleR"
         :key="item.link">
        <img :src="item.picture+'?x-oss-process=image/resize,m_fixed,w_411,h_230/quality,Q_60'"
             :alt="item.title">
        <h2>{{item.title}}</h2>
      </a>
    </section>
  </section>
</template>

<script>
export default {
  props: ["swiperRight", "swiperLeft"],
  data () {
    return {
      articleR: "",
      articleL: "",
      currentIndex: 0,
      timer: ""
    };
  },
  methods: {
    changepage (type) {
      this.stop();
      switch (type) {
        case "left":
          this.currentIndex =
            this.currentIndex === 0
              ? this.articleL.length - 1
              : this.currentIndex - 1;
          break;
        case "right":
          this.currentIndex =
            this.currentIndex === this.articleL.length - 1
              ? 0
              : this.currentIndex + 1;
          break;
      }
      this.go();
    },
    go () {
      this.timer = setInterval(() => {
        this.autoPlay();
      }, 6000);
    },
    stop () {
      clearInterval(this.timer);
      this.timer = null;
    },
    change (index) {
      this.currentIndex = index;
    },
    beforeDestroy () {
      this.stop();
    },
    autoPlay () {
      this.currentIndex++;
      if (this.currentIndex > this.articleL.length - 1) {
        this.currentIndex = 0;
      }
    }
  },
  mounted () {
    clearInterval(this.timer);
    this.articleL = this.swiperLeft;
    this.articleR = this.swiperRight;
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        this.autoPlay();
      }, 6000);
    });
  }
};
</script>
<style scoped lang="less">
.swiper-content {
  display: flex;
  width: 852px;
  height: 326px;
  overflow: hidden;
  justify-content: space-between;

  .carousel-wrap {
    position: relative;
    width: 558px;
    height: 326px;
    overflow: hidden;
    border-radius: 2px;

    &:hover .change-button {
      opacity: 1;
    }

    .change-button {
      width: 40px;
      height: 40px;
      display: block;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-40%);
      font-size: 24px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.4s ease;
    }

    .left {
      left: 0;
      z-index: 20;
    }

    .right {
      right: 0;
    }

    .slide-ul {
      width: 100%;
      height: 100%;
      display: flex;

      li {
        position: absolute;
        width: 100%;

        &:hover p a img {
          height: 105%;
          width: 105%;
        }

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 60px;
          background: rgba(0, 0, 0, 0.7);
        }

        section {
          position: relative;
          overflow: hidden;
          width: 100%;
          height: 326px;

          a {
            img {
              transition: all 0.4s ease;
              width: 100%;
              height: 326px;
              display: inline-block;
              position: relative;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }

            &:hover img {
              width: 105%;
              height: 105%;
            }
          }
        }

        .title {
          font-size: 18px;
          bottom: 0;
          left: 0;
          line-height: 50px;
          padding: 0 10px;
          text-align: center;
          width: 100%;
          height: 60px;
          z-index: 9;
          position: absolute;
          color: #fff;
        }
      }
    }

    .carousel-items {
      position: absolute;
      z-index: 10;
      bottom: 10px;
      width: 100%;
      margin: 0 auto;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 0;

      span {
        display: inline-block;
        height: 4px;
        width: 10px;
        border-radius: 2px;
        margin: 0 3px;
        background-color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
      }

      .active {
        width: 20px;
        background-color: #ffffff;
      }
    }

    .list-enter-active {
      transition: all 0.5s ease;
      transform: translateX(0);
    }

    .list-leave-active {
      transition: all 0.5s ease;
      transform: translateX(-110%);
    }

    .list-enter {
      transform: translateX(100%);
    }

    .list-leave {
      transform: translateX(0);
    }
  }

  .banner-right {
    position: relative;
    width: 274px;
    height: 328px;

    a {
      width: 100%;
      height: 153px;
      display: inline-block;
      position: relative;
      overflow: hidden;
      color: #fff;
      border-radius: 2px;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 45px;
      }

      &:nth-child(1) {
        margin-bottom: 20px;
      }

      &:hover img {
        width: 105%;
        height: 105%;
      }

      img {
        width: 100%;
        height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.4s ease;
      }

      h2 {
        font-size: 14px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        max-height: 65px;
        padding: 10px 10px;
        line-height: 1.3;
        overflow: hidden;
        background: -webkit-linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.6),
          rgba(255, 255, 255, 0)
        );
        /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.6),
          rgba(255, 255, 255, 0)
        );
        /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.6),
          rgba(255, 255, 255, 0)
        );
        /* Firefox 3.6 - 15 */
        background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.6),
          rgba(255, 255, 255, 0)
        );
        /* 标准的语法 */
      }
    }
  }
}
</style>
